import * as types from './types';

export const getNoteTemplateFolders = (payload) => {
  return {
    type: types.GET_NOTE_TEMPLATE_FOLDERS,
    payload,
  };
};

export const getNoteTemplateFoldersSuccess = (payload) => {
  return {
    type: types.GET_NOTE_TEMPLATE_FOLDERS_SUCCESS,
    payload,
  };
};

export const getNoteTemplateFoldersFail = (payload) => {
  return {
    type: types.GET_NOTE_TEMPLATE_FOLDERS_FAIL,
    payload,
  };
};

export const createNoteTemplateFolder = (payload) => {
  return {
    type: types.CREATE_NOTE_TEMPLATE_FOLDER,
    payload,
  };
};

export const createNoteTemplateFolderSuccess = (payload) => {
  return {
    type: types.CREATE_NOTE_TEMPLATE_FOLDER_SUCCESS,
    payload,
  };
};

export const createNoteTemplateFolderFail = (payload) => {
  return {
    type: types.CREATE_NOTE_TEMPLATE_FOLDER_FAIL,
    payload,
  };
};

export const deleteNoteTemplateFolder = (payload) => {
  return {
    type: types.DELETE_NOTE_TEMPLATE_FOLDER,
    payload,
  };
};

export const updateNoteTemplateFolder = (payload) => {
  return {
    type: types.UPDATE_NOTE_TEMPLATE_FOLDER,
    payload,
  };
};

export const reorderNoteTemplateFolders = (payload) => {
  return {
    type: types.REORDER_NOTE_TEMPLATE_FOLDERS,
    payload,
  };
};
